import React, { memo } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import BoxChartTop from "./BoxChartTop";
import BoxChartBottom from "./BoxChartBottom";
import { changeSelectShowInfo, showPopupInfo } from '../redux/actions/sharedActions';
import { priceToNumber, formatNumber } from '../helpers/utils';
import clsx from 'clsx';


const IDXDetailChart = React.lazy(() => import('./index-components/IDXDetailChart'));

export default function PriceBoardIndexBox(props) {
    const priceBoardIndexMode = useSelector(state => state.gShared.priceBoardIndexMode);

    const flag = useSelector(state => state.gIndex.headerIndexes.length);
    const headerIndexes = useSelector(state => state.gIndex.headerIndexes);

    const tabRightMode = useSelector(state => state.gShared.tabRightMode);

    //
    return (
        <div className="index-block">
            <div className={clsx('index-container', (tabRightMode))}>
                {
                    headerIndexes && headerIndexes.length > 0 ? (
                        headerIndexes.map((value, index) => {
                            return (
                                <IndexBoxChild key={index} indexCode={value} priceBoardIndexMode={priceBoardIndexMode} />
                            )
                        })
                    ) : <></>
                }
            </div>
        </div>
    )
}

const IndexBoxChild = memo((props) => {
    const { indexCode, priceBoardIndexMode } = props;

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const language = useSelector(state => state.gShared.language);
    const counter = useSelector(state => state.gIndex.indexInfos.find(el => el.indexCode === indexCode)?.counter);
    const indexInfo = useSelector(state => state.gIndex.indexInfos.find(el => el.indexCode === indexCode)) ?? {};
    //
    const _handleIndexCodeClick = (event, indexCode) => {
        if (indexCode) {
            showPopupInfo(dispatch, "IDX", indexCode);
        }
    }

    const onIndexClick = (event, indexCode) => {
        if (event.target.classList.contains('boxchart__top--name') == false && indexCode) {
            changeSelectShowInfo(dispatch, "IDX", indexCode);
        }
    }

    //
    return (
        <div className={clsx('boxchart', (priceBoardIndexMode && priceBoardIndexMode === 'INFO' ? "info" : priceBoardIndexMode && priceBoardIndexMode === 'HIDDEN' ? 'hidden' : ''))} onClick={(event) => onIndexClick(event, indexInfo.indexCode) ?? null}>


            <div className={clsx('boxchart__grid', (priceBoardIndexMode && priceBoardIndexMode === 'FULL' ? '' : 'hidden'))} style={{ position: 'relative' }}>
                <OverlayTrigger placement='bottom' overlay={
                    <Tooltip style={{ opacity: 1 }}>
                        <p>
                            <span className='text-left'> {t("thap")}: </span><span className={clsx('text-right', indexInfo.lowestIndex_color)}>{formatNumber(indexInfo.lowestIndex)}</span>
                            <span className='text-left'> {t("cao")}: </span><span className={clsx('text-right', indexInfo.highestIndex_color)}>{formatNumber(indexInfo.highestIndex)}</span>
                        </p>
                    </Tooltip>
                }>
                    <div className="boxchart__grid__float" style={{ fontSize: 11, lineHeight: '11px', position: 'absolute', top: 5, right: 6, zIndex: 1 }}>
                        {/* <p className={indexInfo.highestIndex_color}><label style={{margin: 0, padding: 0, pointerEvents: 'none'}}>↗</label> {formatNumber(indexInfo.highestIndex)}</p>
                        <p className={indexInfo.lowestIndex_color}><label style={{ margin: 0, padding: 0, pointerEvents: 'none'}}>↘</label> {formatNumber(indexInfo.lowestIndex)}</p> */}
                        {/* <span className={indexInfo.lowestIndex_color}><label style={{ margin: 0, padding: 0, paddingLeft: 10, pointerEvents: 'none' }}>↘</label> {formatNumber(indexInfo.lowestIndex)}</span>
                        <span className={indexInfo.highestIndex_color}><label style={{ margin: 0, padding: 0, paddingLeft: 10, pointerEvents: 'none' }}>↗</label> {formatNumber(indexInfo.highestIndex)}</span> */}
                    </div>
                </OverlayTrigger>
                <React.Suspense fallback={<p>Loading...</p>}>
                    <IDXDetailChart style={{ height: '100%', width: '100%' }} indexCode={indexInfo.indexCode} priorIndex={priceToNumber(indexInfo.priorIndex)} />
                </React.Suspense>
            </div>

            <BoxChartTop
                onIndexClick={(event) => _handleIndexCodeClick(event, indexInfo.indexCode)}
                name={indexInfo.indexCode}
                current_index={indexInfo.currentIndex}
                change_index={indexInfo.changeIndex}
                change_color={indexInfo.changeIndex_color}
                pct_change_index={indexInfo.pctChangeIndex}
            />
            <BoxChartBottom
                total_volume={indexInfo.totalTradedQtty}
                total_value={indexInfo.totalTradedValue}
                up={indexInfo.up}
                up_ceil={indexInfo.upCeil}
                nochange={indexInfo.noChange}
                down={indexInfo.down}
                down_floor={indexInfo.downFloor}
                status_str={language === 'en' ? indexInfo.statusStrEn : indexInfo.statusStr}
                status={indexInfo.status}
            />

        </div>
    )
})